export { useMenu } from "../molecules/aside/MenuContext";
// Shell del backoffice: se conservan los sidebars como organismos propios. El
// template los movio a molecules/aside y dejo Vertical/TwoColumn desactivados
// (.txt), pero app/backoffice/layout.tsx depende de ellos.
export { default as SidebarHovered } from "./aside/SidebarHovered";
export { default as SidebarTwoColumn } from "./aside/SidebarTwoColumn";
export { default as SidebarVertical } from "./aside/SidebarVertical";
export { default as AsideFilters } from "./asideFilters";
export { default as Calendar } from "./calendar/Calendar";
export { default as CalendarWidget } from "./calendar/CalendarWidget";
export { default as EventsList } from "./calendar/EventsList";
export { default as CardNews } from "./cards/CardNews";
export { default as CardUser01 } from "./cards/cardUser01";
export { default as Categories } from "./cards/categories";
export { default as CardCourse } from "./cards/course";
export { default as JobCard } from "./cards/job";
export { default as CardProject } from "./cards/project";
export { default as ConfirmAccount } from "./ConfirmAccount";
export { default as Bar } from "./graphs/bar";
export { default as Pie } from "./graphs/pie";
export { default as Polar } from "./graphs/polar";
export { default as Grid } from "./grid";
export { default as HorizontalLayout } from "./HorizontalLayout";
export { default as Invoice } from "./Invoice";
export { default as ModeSwitcher } from "./ModeSwitcher";
export { default as Promotion } from "./Promotion";
export { default as Search } from "./Search";
export { default as SelectLayout } from "./SelectLayout";
export { default as ServiceStatus } from "./ServiceStatus";
export { default as SwitchLanguage } from "./SwitchLanguage";

// E-learning (Seguridad Vial) — organismos propios agrupados en ./elearning
export * from "./elearning";

// Shell del backoffice (Seguridad Vial) — organismos propios agrupados en ./backoffice
export * from "./backoffice";
